import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue'
import { authModule, userModule } from '../store'
import Irmao from '../../common/types/Irmao'
import IrmaoService from '../services/IrmaoService'
import { getErrorMessage } from '@/helpers/error-helpers'
import { obterParametrosDeNovosServicos } from '@/shareds/sharedBusca'
import { useQuery } from '@tanstack/vue-query'
import { application } from '@/store'
import dayjs from 'dayjs'
import SomarService from '@/services/SomarService'
import ZoomImage from '@/components/ZoomImage.vue'
import { éVisitante } from '../../common/shareds/sharedAuth'


export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const queryNovosServicos = obterParametrosDeNovosServicos()

const { data: usuario, error } = useQuery({
	queryKey: ['eu'],
	queryFn: IrmaoService.me,
	enabled: authModule.isAuth,
})

const { error: errorNovidades, isFetching } = useQuery({
	queryKey: ['novidades'],
	queryFn: IrmaoService.novidades,
	// só depois de saber quem é o usuário: visitante não tem novidades
	enabled: computed(() => authModule.isAuth && !!usuario.value && !éVisitante(usuario.value)),
})

const { data: somar, error: errorSomar } = useQuery({
	queryKey: ['somar', 'Somar Itapocu'],
	queryFn: () => SomarService.get('Somar Itapocu'),
	enabled: authModule.isAuth,
})

watch(usuario, (valor) => {
	userModule.setCurrentUser(valor || null)
})

const mensagemDeErro = computed(() => {
	return error.value ? getErrorMessage(error.value) : ''
})

const irmao = computed(() => 
  usuario.value && usuario.value.role !== 'Visitante'
    ? usuario.value as Irmao
    : null
)

const visitante = computed(() => éVisitante(usuario.value))

const links = computed(() => {
  const perfil = irmao.value
    ? [{
      icone: 'mdi-account',
      nome: 'Perfil',
      route: { name: 'detalhar-irmao', params: { id: irmao.value._id } },
    }]
    : []
  const servicos = {
    icone: 'mdi-handshake',
    nome: 'Serviços',
    route: { name: 'busca', query: { buscarEm: ['servico'] } },
  }

  if (visitante.value || !irmao.value) return [...perfil, servicos]

  return [
    ...perfil,
    {
      icone: 'mdi-bank',
      nome: 'Loja',
      route: { name: 'detalhar-loja', params: { id: irmao.value.loja._id } },
    },
    {
      icone: 'mdi-web',
      nome: 'Potência',
      route: { name: 'detalhar-potencia', params: { id: irmao.value.potencia._id } },
    },
    {
      icone: 'mdi-math-compass',
      nome: 'Somar',
      route: { name: 'detalhar-somar', params: { id: 'Somar Itapocu' } },
    },
    servicos,
  ]
})

const ehAniversario = computed(() => {
	if (!irmao.value?.dataDeNascimento) return false

	const birthdate = dayjs(irmao.value.dataDeNascimento);
	const today = dayjs();

	return birthdate.date() === today.date() && birthdate.month() === today.month();
})

return { __sfc: true,queryNovosServicos, usuario, error, errorNovidades, isFetching, somar, errorSomar, mensagemDeErro, irmao, visitante, links, ehAniversario, getErrorMessage, application, dayjs, ZoomImage }
}

})